const mappings = [
    ['purchasePrice', 'pp'],
    ['deposit', 'd'],
    ['costsRefurbishment','cr'],
    ['income','i'],
    ['costsMonthlyManagement','cm'],
    ['costsMonthlyBills','cb'],
    ['costsMonthlyOther','co'],
    ['interestRate','ir'],
    ['otherBuyingFees','of'],
    ['propertyName','pn'],
    ['nonPropertyEarnings', 'npe'], 
    ['nonPropertyDividendIncome', 'di'],
    ['purchaseLimited', 'pl'],
    ['goal', 'g'],
    ['projectionYears', 'py'],
    ['profitGoal', 'pg'],
    ['additionalAnnualInvestment', 'ai']
]


export const toQS = (state) => {
    let qs = [];
    mappings.forEach(mapping => {
        let qsKey = mapping[1];
        let qsValue = state[mapping[0]];
        if (qsValue && qsValue !== 0) {
            qs.push(qsKey + '=' + qsValue); 
        }
    })
    return qs.join('&');
}

export const fromQS = (qs) => {
    // Transform our mappings to speed up lookup:
    let mappingsByQS = {};
    mappings.forEach(value => {
        mappingsByQS[value[1]] = value[0];
    });

    let query = {};
    const pairs = (qs[0] === '?' ? qs.substr(1) : qs).split('&');
    pairs.forEach(qsPair => {
        const pair = qsPair.split('=');
        const keyName = mappingsByQS[decodeURIComponent(pair[0])];
        if (keyName) {
            query[keyName] = decodeURIComponent(pair[1] || '');        
        }
    })

    return query;

}


// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/QSMapper.js